import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  allowedCardNumber,
  formatSelect,
  lengthValidation64,
  onlyNumeric,
  required,
} from '../Forms/utils';
import { getFullName } from '../Person/utils';

import {
  DATE_PICKER,
  MESSAGE,
  REACT_SELECT_INPUT,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const AccessCardFormComponent = (props) => {
  const {
    form,
    onSubmit,
    initialValues,
    preselectedPerson,
    personsProperties,
    selectedPersonId,
    selectedPerson,
    isRegistered,
    hasVerifiedPhoneNumber,
    batchOptions,
    selectedBatch,
    isCreate,
    buildings,
    personOptions,
    selectedBuildingId,
    isLyazonType,
    selectedType,
    batch,
  } = props;

  const formData = [
    {
      keyName: 'accessCardBatch',
      label: 'Access Card Batch',
      fieldType: REACT_SELECT_INPUT,
      options: batchOptions,
      validate: [required],
    },
    {
      keyName: 'number',
      label: 'Number',
      fieldType: STYLED_TEXT,
      validate: isLyazonType
        ? [required, lengthValidation64]
        : [required, onlyNumeric, allowedCardNumber],
      isHidden: !selectedBatch,
    },
    {
      keyName: 'scanCode',
      label: 'Scan Code',
      fieldType: STYLED_TEXT,
      validate: [],
      isHidden: isCreate,
      disabled: true,
    },
    {
      keyName: 'effectiveDate',
      label: 'Effective Date',
      fieldType: DATE_PICKER,
      validate: [required],
    },
    {
      keyName: 'validUntil',
      label: 'Valid Until',
      fieldType: DATE_PICKER,
      validate: [],
    },
    {
      keyName: 'building',
      label: 'Building',
      fieldType: REACT_SELECT_INPUT,
      options: formatSelect(Object.values(buildings)),
      validate: [required],
      disabled: !selectedType,
    },
    {
      keyName: 'person',
      label: 'Person',
      fieldType: REACT_SELECT_INPUT,
      options: personOptions,
      validate: [required],
      disabled: preselectedPerson,
      isHidden: !selectedBuildingId,
    },
    {
      keyName: 'message',
      fieldType: MESSAGE,
      value: `Note - ${getFullName(
        selectedPerson,
      )} will only be added to the intercom when s/he has a verified phone number or completes the registration with Carson.`,
      isHidden:
        !selectedPersonId ||
        (selectedPersonId && isRegistered) ||
        (selectedPersonId && !isRegistered && hasVerifiedPhoneNumber),
    },
    {
      keyName: 'properties',
      label: 'Properties',
      fieldType: REACT_SELECT_INPUT,
      options: personsProperties,
      validate: [required],
      isHidden: !selectedPersonId,
      disabled: preselectedPerson,
      multi: true,
    },
    {
      keyName: 'type',
      label: 'Type',
      fieldType: STYLED_TEXT,
      validate: [required],
      isHidden: true,
    },
  ];
  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      title={`${isCreate ? 'Add' : 'Update'} Access Card`}
      submitText={isCreate ? 'Create Card' : 'Update Card'}
      batch={batch}
      isSkeletonDisabled
    />
  );
};
AccessCardFormComponent.defaultProps = {
  personsProperties: [],
  selectedPersonId: null,
  isRegistered: false,
  batchOptions: [],
  selectedBatch: null,
  isCreate: false,
  buildings: {},
  personOptions: [],
  selectedBuildingId: null,
  selectedPerson: null,
  hasVerifiedPhoneNumber: false,
  preselectedPerson: null,
  selectedType: null,
};
AccessCardFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  preselectedPerson: PropTypes.instanceOf(Object),
  personsProperties: PropTypes.instanceOf(Array),
  selectedPersonId: PropTypes.number,
  selectedPerson: PropTypes.instanceOf(Object),
  isRegistered: PropTypes.bool,
  hasVerifiedPhoneNumber: PropTypes.bool,
  batchOptions: PropTypes.instanceOf(Array),
  selectedBatch: PropTypes.number,
  isCreate: PropTypes.bool,
  buildings: PropTypes.instanceOf(Object),
  personOptions: PropTypes.instanceOf(Array),
  batch: PropTypes.instanceOf(Object),
  selectedBuildingId: PropTypes.number,
  isLyazonType: PropTypes.bool.isRequired,
  selectedType: PropTypes.string,
};

export default AccessCardFormComponent;
